export default {
  PHOTOGRAPHE: "photographe",
  MAIRIE: "mairie",
  SIV: "siv",
};
